module.exports = __webpack_public_path__ + "static/media/ear.0d550526.jpeg";